var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppCommunityAssets({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#1E3101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0996 35.3125V34.1125C40.0996 33.9125 40.1996 33.7125 40.2996 33.6125C41.1996 32.5125 41.6996 31.2125 41.6996 29.8125C41.6996 26.9125 40.1996 25.3125 37.8996 25.3125C35.5996 25.3125 33.9996 27.0125 33.9996 29.8125C33.9996 31.2125 34.4996 32.5125 35.3996 33.6125C35.4996 33.7125 35.5996 33.9125 35.5996 34.1125V35.2125C35.5996 35.6125 35.2996 35.9125 34.8996 36.0125C30.2996 36.4125 29.5996 39.6125 29.5996 40.8125C29.5996 40.9125 29.5996 41.5125 29.5996 41.6125H46.0996C46.0996 41.6125 46.0996 40.9125 46.0996 40.8125C46.0996 39.6125 45.2996 36.5125 40.7996 36.0125C40.3996 36.0125 40.0996 35.7125 40.0996 35.3125Z",
    fill: "#99E83F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29.8117C32 29.7117 32 29.6117 32 29.5117L25.5 32.7117V25.2117L37.9 19.0117V23.2117C38.6 23.2117 39.3 23.3117 40 23.6117V17.4117C40 17.0117 39.8 16.7117 39.4 16.5117L31.7 12.6117C31.1 12.3117 30.4 12.3117 29.8 12.6117L24.5 15.3117L19.2 12.6117C18.6 12.3117 17.9 12.3117 17.3 12.6117L9.6 16.5117C9.3 16.7117 9 17.0117 9 17.4117V26.6117C9 27.4117 9.4 28.1117 10.1 28.4117L23.6 35.2117C24.2 35.5117 24.9 35.5117 25.4 35.2117L32.2 31.8117C32.1 31.1117 32 30.5117 32 29.8117ZM23.5 32.8117L11.1 26.6117V19.1117L23.5 25.3117V32.8117Z",
    fill: "#99E83F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppCommunityAssets);
export default __webpack_public_path__ + "static/media/B_app_communityAssets.439c8418806fc15923e16b4bac7e76b6.svg";
export { ForwardRef as ReactComponent };